import { takeLatest, call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { delay } from 'redux-saga';

import {
  setHeadersFromLocalStorage,
  deleteHeaders,
} from 'data_system/token_auth/utils';
import { PORTAL_DISABLED } from 'ui_system/token_auth/routes';
import {
  VALIDATE_TOKEN_REQUEST,
  LOGIN_REQUEST,
  RESET_PASSWORD_REQUEST,
  LOGOUT_REQUEST,
  LOGIN,
  LOGOUT,
  AUTH_ERRORS,
  SESSION_TIMEOUT,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_ERROR,
  SHOW_NOTICE,
  HIDE_NOTICE,
  SUBMIT_COMPLETED,
} from 'data_system/token_auth/actionTypes';
import { getResErrors } from 'data_system/token_auth/selectors';
import { validateTokenComplete } from 'data_system/token_auth/actions';
import Api from 'data_system/affiliate_portal/api/rootApi';
import { createSagas } from 'data_system/token_auth/createSagas';

const sharedSagas = createSagas({ Api });

// Only fired when form is submitted by the user
// Skipped when "Logged In" via a validated token from a previous session
function* loginUser({ params }) {
  try {
    const { email, rememberMe } = params;
    const res = yield call(Api.loginUser, params);

    // Save their email for when they come back to the login page.
    if (rememberMe) {
      localStorage.setItem('email', email);
    } else {
      localStorage.removeItem('email');
    }

    yield put({ type: LOGIN, res });
  } catch (res) {
    if (res.response.status === 403) {
      yield put(push(PORTAL_DISABLED));
      yield put({ type: SUBMIT_COMPLETED });
    } else {
      yield put({ type: AUTH_ERRORS, errors: getResErrors(res) });
    }
  }
}

function* resetPassword({ params }) {
  try {
    const res = yield call(Api.resetPassword, params);
    yield put({ type: LOGIN, res });
  } catch (res) {
    yield put({ type: AUTH_ERRORS, errors: getResErrors(res) });
  }
}

function* validateToken() {
  try {
    setHeadersFromLocalStorage();
    const res = yield call(Api.validateToken);
    yield put({ type: LOGIN, res });

    yield put(validateTokenComplete);
  } catch (res) {
    yield put(validateTokenComplete);
    deleteHeaders();
  }
}

function* logoutUser({ type }) {
  try {
    yield call(Api.logoutUser);
    deleteHeaders();
    // If it's SESSION_TIMEOUT, let user click on timeout modal before deleting the user in Redux
    if (type === LOGOUT_REQUEST) yield put({ type: LOGOUT });
  } catch (res) {
    yield put({ type: AUTH_ERRORS, errors: getResErrors(res) });
  }
}

function* updatePassword({ params }) {
  try {
    yield call(Api.updatePassword, params);
    yield put({
      type: SHOW_NOTICE,
      noticeText: 'Password updated successfully',
    });
    // Wait for 3 secs before hiding notification
    yield delay(3000);
    yield put({ type: HIDE_NOTICE });
  } catch (res) {
    yield put({ type: UPDATE_PASSWORD_ERROR, errors: getResErrors(res) });
  }
}

export const authSagas = [
  ...sharedSagas,
  takeLatest(LOGIN_REQUEST, loginUser),
  takeLatest(RESET_PASSWORD_REQUEST, resetPassword),
  takeLatest(UPDATE_PASSWORD_REQUEST, updatePassword),
  takeLatest(VALIDATE_TOKEN_REQUEST, validateToken),
  takeLatest(LOGOUT_REQUEST, logoutUser),
  takeLatest(SESSION_TIMEOUT, logoutUser),
];
